import React, { useMemo } from "react"
import { baseUrlImg } from "../../config/api"

function formatDate(dateString) {
  if (!dateString) return "-"
  const date = new Date(dateString)
  return date.toLocaleString("it-IT", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  })
}

const GWebTicket = ({ arr }) => {
  const receiptData = useMemo(() => {
    try {
      return arr.receipt ? JSON.parse(arr.receipt) : {}
    } catch {
      return {}
    }
  }, [arr.receipt])

  return (
    <div style={{ fontFamily: "monospace", maxWidth: 420 }}>
      
      <div className="d-flex justify-content-center mb-3">
        <img src={`${baseUrlImg}/${arr.logo}`} alt="logo" height={50} />
      </div>

      <div style={rowStyle}>
        <span>Data:</span>
        <span>{formatDate(arr.created_at)}</span>
      </div>

      <div style={rowStyle}>
        <span>Order ID:</span>
        <span>{receiptData.order_id || "-"}</span>
      </div>

      {receiptData.evoucher?.map((v, i) => (
        <div key={i} style={{ marginBottom: 8 }}>
          <div style={rowStyle}>
            <span>Codice:</span>
            <span>{v.codice}</span>
          </div>

          <div style={rowStyle}>
            <span>Scadenza:</span>
            <span>{v.expdate}</span>
          </div>
        </div>
      ))}

      {receiptData.evoucher_url && (
        <div style={{ marginTop: 10 }}>
          <div style={{ marginBottom: 5 }}>
            Scarica il voucher:
          </div>
          <a
            href={receiptData.evoucher_url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#3b82f6",
              textDecoration: "underline",
              wordBreak: "break-all",
            }}
          >
            {receiptData.evoucher_url}
          </a>
        </div>
      )}
    </div>
  )
}

const rowStyle = {
  display: "flex",
  justifyContent: "space-between",
  padding: "6px 0",
  borderBottom: "1px dashed #6b7280",
}

export default GWebTicket